import { POST_POI_PACKAGE_DATA_TYPE } from '../../constants';

export const getPOIPoints = (value) => {
  return {
    type: 'GET_POI_POINTS',
    payload: value,
  };
};

export const resetGetPOIPoints = () => {
  return {
    type: 'GET_POI_POINTS_RESET',
  };
};

export const postPOIPackage = (value) => {
  return {
    type: POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE,
    payload: value,
  };
};

export const getPOIPackageById = (value) => {
  return {
    type: POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID,
    payload: value,
  };
};

export const resetGetPoiPointsById = () => {
  return {
    type: POST_POI_PACKAGE_DATA_TYPE.GET_POI_PACKAGE_BY_ID_RESET,
  };
};

export const resetPostPOIPackage = () => {
  return {
    type: POST_POI_PACKAGE_DATA_TYPE.POST_POI_PACKAGE_RESET,
  };
};
export const putPoiPackageRemovePoi = (value) => {
  return {
    type: POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI,
    payload: value,
  };
};
export const resetPutPoiPackageRemovePoi = () => {
  return {
    type: POST_POI_PACKAGE_DATA_TYPE.PUT_POI_PACKAGE_REMOVE_POI_RESET,
  };
};
